var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Select } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback, useMemo } from 'react';
import styles from './flagSelect.module.scss';
const FlagSelect = ({ disabled, isLoading, items, onSelect, onSearch, pagination, placeholder: propsPlaceholder, selectedItem, }) => {
    const placeholder = isLoading ? 'Loading...' : propsPlaceholder;
    const selectedItems = selectedItem && !isLoading ? [selectedItem] : undefined;
    const selectedFlag = useMemo(() => { var _a, _b; return (_b = (_a = items.find(({ id }) => id === selectedItem)) === null || _a === void 0 ? void 0 : _a.flag) === null || _b === void 0 ? void 0 : _b.toLowerCase(); }, [items, selectedItem]);
    const itemComponent = useCallback((props) => {
        const { item: { id, flag, name }, item, disabled, onSelect } = props, otherProps = __rest(props, ["item", "item", "disabled", "onSelect"]);
        const country = (flag === null || flag === void 0 ? void 0 : flag.toLowerCase()) || '';
        return (_createElement("button", Object.assign({}, otherProps, { type: "button", className: styles.item, onClick: () => onSelect(item), key: id, disabled: disabled }),
            _jsx("span", { className: classnames(`flag ${country}`, styles.itemFlag) }),
            _jsx("span", Object.assign({ className: styles.itemName }, { children: name }))));
    }, []);
    const prefix = {
        noWrap: true,
        type: 'custom',
        value: (_jsx("div", Object.assign({ className: styles.selectPrefix }, { children: _jsx("span", { className: classnames('flag', selectedFlag) }) }))),
    };
    const isPrefixShown = !isLoading && !!selectedFlag;
    return (_jsx(Select, { className: classnames('flags', styles.select), disabled: disabled || isLoading, itemComponent: itemComponent, items: items, onSearch: onSearch, onSelect: onSelect, pagination: pagination, placeholder: placeholder, prefix: isPrefixShown && prefix, searchable: true, selectedItems: selectedItems }));
};
export default FlagSelect;
